export const currencyFormatOptions: Intl.NumberFormatOptions = {
  style: 'currency',
  currency: 'EUR',
  useGrouping: false
}

export const formatCurrency = new Intl.NumberFormat(undefined, currencyFormatOptions)